
import { Component, Vue, Prop, Emit, Model, Watch } from "vue-property-decorator"

@Component({
})
export default class SortHeader extends Vue {
	@Prop({ required: true })
	tableSort!: string

	@Prop({ default: true })
	tableSortDesc!: boolean

	@Prop({ required: true })
	columnKey!: string

	get ariaSort (): string {
		if (this.tableSort !== this.columnKey) return "none"
		if (this.tableSortDesc) return "descending"
		return "ascending"
	}

	get clickDescriptionSort (): string {
		if (this.tableSort !== this.columnKey) return "ascending"
		if (this.tableSortDesc) return "ascending"
		return "descending"
	}

	columnHeaderClick () {
		if (this.tableSort !== this.columnKey) {
			this.$emit("update:tableSort", this.columnKey)
			this.$emit("update:tableSortDesc", false)
		} else {
			this.$emit("update:tableSortDesc", !this.tableSortDesc)
		}
	}
}
